// extracted by mini-css-extract-plugin
export default {"commentsIcon":"CommentsIcon_commentsIcon__lwYou"};